// AIScorePanel — Claude-powered analysis quality preview (0-100 + rationale + risks).
import React from "react";
import { tFases } from "../../../i18n/shadow-fases";

export const AIScorePanel = ({ lang, aiScore, aiBusy, aiErr, onRequest }) => (
  <div className="mt-4 rounded-2xl border border-violet-400/20 bg-violet-400/[0.03] p-3">
    <div className="flex items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <span className="text-[10px] font-black uppercase tracking-[0.22em] text-violet-200">
          🤖 {tFases(lang, "publish_ai_label")}
        </span>
        <span className="text-[10px] text-white/40">{tFases(lang, "publish_ai_sub")}</span>
      </div>
      <button
        type="button"
        onClick={onRequest}
        disabled={aiBusy}
        data-testid="ai-score-preview-btn"
        className="inline-flex items-center gap-1 rounded-full border border-violet-400/40 bg-violet-400/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-violet-200 hover:bg-violet-400/20 disabled:opacity-60"
      >
        {aiBusy ? tFases(lang, "publish_ai_busy") : tFases(lang, "publish_ai_btn")}
      </button>
    </div>
    {aiErr && (
      <p className="mt-2 text-[11px] text-rose-300" data-testid="ai-score-error">{aiErr}</p>
    )}
    {aiScore && (
      <div className="mt-3 rounded-xl border border-violet-400/20 bg-black/40 p-3" data-testid="ai-score-result">
        <div className="flex items-center justify-between">
          <span className="font-mono text-3xl font-black text-violet-200">
            {aiScore.score}<span className="text-base text-white/40">/100</span>
          </span>
          <div className="h-2.5 flex-1 ml-4 overflow-hidden rounded-full bg-white/[0.05]">
            <div
              className="h-full bg-gradient-to-r from-violet-400 to-fuchsia-400 transition-all duration-700"
              style={{ width: `${aiScore.score}%` }}
            />
          </div>
        </div>
        {aiScore.rationale && (
          <p className="mt-3 text-[11px] leading-relaxed text-white/70">💡 {aiScore.rationale}</p>
        )}
        {Array.isArray(aiScore.key_risks) && aiScore.key_risks.length > 0 && (
          <div className="mt-2">
            <p className="text-[9px] font-mono uppercase tracking-[0.22em] text-amber-300/80">
              {tFases(lang, "publish_ai_risks")}
            </p>
            <ul className="mt-1 space-y-0.5">
              {aiScore.key_risks.map((r, i) => (
                <li key={i} className="text-[11px] text-white/60">⚠️ {r}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )}
  </div>
);

export default AIScorePanel;
